// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PInsuranceOutlinedSvg from "@fishx/icons-svg/es/asn/PInsuranceOutlined";
import FishxIcon from '../components/FishxIcon';

var PInsuranceOutlined = function PInsuranceOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PInsuranceOutlinedSvg
  }));
};

PInsuranceOutlined.displayName = 'PInsuranceOutlined';
export default React.forwardRef(PInsuranceOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PInsuranceOutlined.js
// module id = 3468
// module chunks = 0